module.exports = __webpack_public_path__ + "static/img/ag_1.b330cd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_1.png
// module id = 867
// module chunks = 1